import { ChooseCardStepModel, IChooseCardStepModel } from "./ChooseCardsStep.model";
import { ChooseRecipientsStepModel, IChooseRecipientsStepModel } from "./ChooseRecipientsStep.model";
import { ChooseSenderStepModel, IChooseSenderStepModel } from "./ChooseSenderStep.model";

export interface IChooseCardSubpageModel {
    chooseCardDetails: IChooseCardStepModel;
    chooseRecipients: IChooseRecipientsStepModel;
    chooseSender: IChooseSenderStepModel;
}

export class ChooseCardSubpageModel implements IChooseCardSubpageModel {
    chooseCardDetails: IChooseCardStepModel;
    chooseRecipients: IChooseRecipientsStepModel;
    chooseSender: IChooseSenderStepModel;

    constructor() {
        this.chooseCardDetails = new ChooseCardStepModel();
        this.chooseRecipients = new ChooseRecipientsStepModel();
        this.chooseSender = new ChooseSenderStepModel();
    }

    static isValid(model: IChooseCardSubpageModel): boolean {
        return ChooseCardStepModel.isValid(model.chooseCardDetails, null) &&
            ChooseRecipientsStepModel.isValid(model.chooseRecipients) &&
            ChooseSenderStepModel.isValid(model.chooseSender);
    }
}